import { WhitelistingStatus } from "../enums/whitelisting.enums";

export const MESSAGE_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
};

export const SOL_SYMBOL = "SOL";
export const EMPTY_STRING = "";
export const ENTER_KEY_CODE = 13;
export const TEXTAREA = "TEXTAREA";
export const SESSION_CLUB_KEY = "clubData";
export const DEFAULT_TIMEOUT = 30000;

export const Y_SCROLL_POSITION_FOR_SCROLL_BUTTON = 100;

export const SKELETON_BROWSE_CLUBS_QUANTITY = 8;
export const SKELETON_PROPOSALS = 8;
export const AMOUNT_SKELETON_NFTS = 12;
export const NFT_SKELETON_AMOUNT = 9;

export const SYNDICATE_MONKE_FEE = 1.025;

export const INITIAL_MEMBERS_CARDS_COUNT = 9;
export const INITIAL_PROPOSAL_CARDS_COUNT = 8;
export const INITIAL_VAULT_NFTS_COUNT = 6;

export const SPL_PROGRAM_VERSION = 2;
export const SPL_PROGRAM_VERSION_V3 = 3;

export const DASHBOARD_CARDS_COUNT = 8;

export const TOKEN_LIST_RENDER_ITEMS_NUMBER = 4;

export const NATIVE_MINT_DECIMAL_PLACES = 9;
export const UNQ_PER_AMOUNT = 1000000;

export const MAX_VOTING_POWER = 1000000;
export const MAX_PROPOSAL_DESCRIPTION_LENGTH = 500;

export const MAX_DEPOSIT_AMOUNT = 7;
export const SOL_DECIMAL_PLACES = 0.000000001;
export const PERCETANGE_DECIMAL_PLACES = 0.01;

export const INITIAL_SELL_PERMISSION_CONFIG_COUNT = 4;

export const MAX_NFT_VOTES = 1000000;
export const MAX_TAGS_ALLOWED = 9;
export const TOTAL_FEES = "totalFees";

export const MANAGEMENT_FEE_PERCENTAGE = 2.5;

export const MAX_IMAGE_SIZE = 2000000;
export const MAX_USERNAME_LENGTH = 18;
export const MAX_TRADE_APPROVAL_QUORUM = 10;

export const TRANSACTION_ERROR_IDENTIFIER = "Error Message: ";
export const GOVERNANCE_ERROR_IDENTIFIER = "GOVERNANCE-ERROR: ";
export const TRANSFER_ERROR_IDENTIFIER = "Transfer: ";
export const INVALID_ACCOUNT_STATE_ERROR = "Invalid account state.";
export const HTTPS = "https://";
export const CHAIN_ID = "sol";

export const REMAINING_ACCOUNTS_PER_IX = 12;
export const ROLES_PER_IX = 6;

export const REMAINING_ACCOUNTS_PER_ADD_MEMBER_IX = 24;

export const TREASURY_INDEX = 0;

export const PROPOSAL_TYPE = "proposalType";

export const USDC_ADDRESS = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";

export const MISSING_TOKEN_DETAILS: Map<
  string,
  {
    address: string;
    decimals: 6;
    logoURI: string;
    name: string;
    symbol: string;
  }
> = new Map([
  [
    USDC_ADDRESS,
    {
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
      decimals: 6,
      logoURI:
        "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v/logo.png",
      name: "USD Coin",
      symbol: "USDC",
    },
  ],
]);

export const ACCOUNT_RENT = 890880;
export const MAX_STAKING_ACC_NAME_LENGTH = 20;

export const MAX_DESCRIPTION_LENGTH = 150;

export const USER_REJECTED = "User rejected";
export const MILLISECONDS_PER_SECOND = 1000;

export const MAX_MAGIC_EDEN_CPI_RETRYS = 10;

export const ADD_SELL_PERMISSION = "addSellPermission";

export const OFFER_STATUS_OFFSET = 32 + 32 + 8 + 32 + 8 + 4 * 32;
export const MILISECONDS_PER_SECOND = 1000;
export const SIXTY_SECONDS = 60;
export const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 500000;

export const localeStringOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 9,
};
export const localeStringOptionsUnqTokens = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
};

//COLORS
export const RED_COLOR = "#FD2B2B0D";
export const GREEN_COLOR = "#2BFDA70D";
export const BLUE_COLOR = "#38D6F90D";
export const INPUT_COLOR = "#122242";
export const GREEN_TEXT_COLOR = "#2bfda7";
export const BLUE_TEXT_COLOR = "#38D6F9";
export const RED_TEXT_COLOR = "#EE4C4C";

export const GOVERNANCE_CONFIG_SIZE = 31;

export const TERMS_OF_USE_PDF_URL =
  "https://unique.vc/docs/Unique_Venture_Clubs_-_Terms_of_Use.pdf";
export const DISCLAIMERS_PDF_URL =
  "https://unique.vc/docs/Unique_Venture_Clubs_-_Disclaimers.pdf";
export const PRIVACY_POLICY_PDF_URL =
  "https://unique.vc/docs/Unique_Venture_Clubs_-_Privacy_Policy.pdf";

export const customStyles = {
  option: () => ({
    cursor: "pointer",
    padding: "1em 1em",
    fontSize: "14px",
    fontFamily: "Montserrat,sans-serif",
    fontWeight: 600,
    backgroundColor: "rgba(255, 255, 255, 0.03)",
    margin: 0,
    zIndex: 50,
    width: "100%",
    color: "white",
    "&:hover": {
      opacity: 0.7,
      color: "white",
      cursor: "pointer",
    },
  }),
  container: (provided) => ({
    ...provided,
    fontFamily: "Montserrat,sans-serif",
    fontSize: "14px",
    marginTop: "10px",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    border: "1px solid white",
    borderRadius: "8px",
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: "#0C121D",
    borderRadius: "8px",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    color: "white",
    fontWeight: "700",
    padding: "0.5em",
    borderRadius: "8px",
    border: "1px solid white",
    fontSize: "1em",
    display: "flex",
    gap: "0.5em",
    justifyContent: "center",
    alignItems: "center",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white ",
    fontFamily: "Montserrat",
    margin: "0.2em",
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    padding: "0.1em",
    borderRadius: "10px",
    border: "1px solid white",
    "&:hover": {
      backgroundColor: "#040e24",
      color: "white",
    },
  }),
  input: (provided) => ({
    ...provided,
    color: "white",
    fontSize: "1.25em",
    marginLeft: "1em",
    height: "2.5em",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    color: "white",
    padding: "0.5em",
    overflow: "hidden",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "1.2em",
    fontWeight: "100",
    fontFamily: "Montserrat, sans-serif",
    marginLeft: "1em",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "10px",
    fontSize: "13px",
    cursor: "pointer",
    background: "rgba(255, 255, 255, 0.03)",
    border: "none",
    color: "white",
    fontFamily: "Montserrat",
    boxShadow: "none",
    minHeight: "5em",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: "3px",
  }),
};

export const whitelistingStatusColor: Map<WhitelistingStatus, string[]> =
  new Map([
    [
      WhitelistingStatus.Approved,
      [GREEN_COLOR, GREEN_TEXT_COLOR, "Your whitelisting request is approved!"],
    ],
    [
      WhitelistingStatus.Denied,
      [
        RED_COLOR,
        RED_TEXT_COLOR,
        "Your application for using platform has been denied. You can send new application by filling the information and submitting the form.",
      ],
    ],
    [
      WhitelistingStatus.Pending,
      [
        BLUE_COLOR,
        BLUE_TEXT_COLOR,
        "Your application for using platform has been successfully created and is being processed now.",
      ],
    ],
  ]);
